var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackspaceSquarekeyboard = function SvgBackspaceSquarekeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 0H7c-.69 0-1.23.35-1.59.88L0 9l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm0 16H7.07L2.4 9l4.66-7H22v14Zm-11.59-2L14 10.41 17.59 14 19 12.59 15.41 9 19 5.41 17.59 4 14 7.59 10.41 4 9 5.41 12.59 9 9 12.59 10.41 14Z"
  })));
};
export default SvgBackspaceSquarekeyboard;